module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC2SURBVHgB7ZRLEQIxEESTFAIiAQk4AByAA1DAGkhCEgUoYHGAAyxgAQerIKFTBZx2hk9Re9n0tdNv+pAZIaqGluTMGOMu5zzrDUqpU0o3+Huo63szYdgC4aVzbkX5gG6UUsVvv4aj3RztL8wTjeYHymTh0NkYs6XMR3MyTDt/UIVX+Od6988XIYQjZWLJplii06/wq7X2tUTe+xaw5nlLMLjBiejI4Ry5hMsJAJACaAxfi6px6A4yH0BKBtXlUAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile-24.png
// module id = +n+S
// module chunks = 1